var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
const failsafeModelNumber = '-MKL0UJNMS-yBoeWcuNv';
const productInfo = {
    '-O45rfxbX7MEjS3XjRDL': {
        name: 'UXC-4x3-TPX-TX20',
        apiSyntax: 'ucx',
        audioOutput: 4,
        cmdPath: '/VIDEO/XP',
        volumeCommand: 'VolumedB',
    },
    '-O45rtpyhmQgodoFD36Q': {
        name: 'UXC-2x1-TPX-TX20',
        apiSyntax: 'ucx',
        audioOutput: 2,
        cmdPath: '/VIDEO/XP',
        volumeCommand: 'VolumedB',
    },
    '-Nmq6GE3pW2kAKBfIA2h': {
        name: 'UXC-4x3-HC40',
        apiSyntax: 'ucx',
        audioOutput: 4,
        cmdPath: '/VIDEO/XP',
        volumeCommand: 'VolumedB',
    },
    '-Ntv3Sj67fTq4A2V_29Q': {
        name: 'UXC-4x2-HC40',
        apiSyntax: 'ucx',
        audioOutput: 3,
        cmdPath: '/VIDEO/XP',
        volumeCommand: 'VolumedB',
    },
    '-NlupWdbG_OwEvxxxl2o': {
        name: 'UXC-2x2-H30',
        apiSyntax: 'ucx',
        audioOutput: 3,
        cmdPath: '/VIDEO/XP',
        volumeCommand: 'VolumedB',
    },
    '-NmhIhicf3yUUhVHRoiz': {
        name: 'UXC-2x1-HC30',
        apiSyntax: 'ucx',
        audioOutput: 2,
        cmdPath: '/VIDEO/XP',
        volumeCommand: 'VolumedB',
    },
    '-MWioBRNG33X6RLej79n': {
        name: 'UXC-4x2-HC30',
        apiSyntax: 'ucx',
        audioOutput: 3,
        cmdPath: '/VIDEO/XP',
        volumeCommand: 'VolumedB',
    },
    '-MWioFpGIAVocTaOQvRD': {
        name: 'UXC-4x2-HC30D',
        apiSyntax: 'ucx',
        audioOutput: 3,
        cmdPath: '/VIDEO/XP',
        volumeCommand: 'VolumedB',
    },
    '-MKL0UJNMS-yBoeWcuNv': {
        name: 'MMX4x2-HDMI',
        apiSyntax: 'mmx',
        audioOutput: 3,
        cmdPath: '/VIDEO/XP',
        volumeCommand: 'VolumedB',
    },
    '-Mwx6JDJGFtgxE916I9j': {
        name: 'MMX4x2-HDMI-USB20-L',
        apiSyntax: 'mmx',
        audioOutput: 3,
        cmdPath: '/VIDEO/XP',
        volumeCommand: 'VolumedB',
        hasUsbSwitch: true,
        hasAutoSwitch: true,
    },
    '-MKL0ahLpNhJFXoe0fzL': {
        name: 'MMX4x2-HT200',
        apiSyntax: 'mmx',
        audioOutput: 3,
        cmdPath: '/VIDEO/XP',
        volumeCommand: 'VolumedB',
    },
    '-MKL0dTMMJE70eWIn_Cq': {
        name: 'MMX6x2-HT200 / 210 / 220"',
        apiSyntax: 'mmx',
        audioOutput: 5,
        cmdPath: '/VIDEO/XP',
        volumeCommand: 'Volume',
    },
    '-MKL0gLW-ryO-GGNVGKf': {
        name: 'MMX8x4-HT400MC',
        apiSyntax: 'mmx',
        audioOutput: 6,
        cmdPath: '/VIDEO/XP',
        volumeCommand: 'Volume',
    },
    '-MKL0jfOqmJgkwfB9f4p': {
        name: 'MMX8x4-HT420M',
        apiSyntax: 'mmx',
        audioOutput: 6,
        cmdPath: '/VIDEO/XP',
        volumeCommand: 'Volume',
    },
    '-MKL0n_swllwolmpNUcl': {
        name: 'MMX8x8-HDMI-4K-A',
        apiSyntax: 'mmx',
        audioOutput: 8,
        cmdPath: '/VIDEO/XP',
        volumeCommand: 'Volume',
    },
    '-MskKZUVNBVlCbYfM-35': {
        apiSyntax: 'mmx',
        cmdPath: '/XP/VIDEO',
        connectionStatus: 'DestinationConnectionStatus',
        name: 'MX2-16x16-DH-8DPI-A-R',
    },
    '-MskKZUWdELDgKs5OHNQ': {
        apiSyntax: 'mmx',
        cmdPath: '/XP/VIDEO',
        connectionStatus: 'DestinationConnectionStatus',
        firmwareQuery: 'GET /MANAGEMENT/UID.FirmwareVersion',
        name: 'MX2-4x4-HDMI20-CA',
    },
    '-MskKZUWdELDgKs5OHNR': {
        apiSyntax: 'mmx',
        cmdPath: '/XP/VIDEO',
        connectionStatus: 'DestinationConnectionStatus',
        firmwareQuery: 'GET /MANAGEMENT/UID.FirmwareVersion',
        name: 'MX2-8x4-HDMI20-CA',
    },
    '-MskKZUXwO1EmaFzs690': {
        apiSyntax: 'mmx',
        cmdPath: '/XP/VIDEO',
        connectionStatus: 'DestinationConnectionStatus',
        firmwareQuery: 'GET /MANAGEMENT/UID.FirmwareVersion',
        name: 'MX2-8x8-HDMI20-CA',
    },
    '-MskKZUXwO1EmaFzs691': {
        apiSyntax: 'mmx',
        cmdPath: '/XP/VIDEO',
        connectionStatus: 'DestinationConnectionStatus',
        firmwareQuery: 'GET /MANAGEMENT/UID.FirmwareVersion',
        name: 'MX2-8x8-DH-4DPI-A',
    },
    '-MskKZUXwO1EmaFzs692': {
        apiSyntax: 'mmx',
        cmdPath: '/XP/VIDEO',
        connectionStatus: 'DestinationConnectionStatus',
        firmwareQuery: 'GET /MANAGEMENT/UID.FirmwareVersion',
        name: 'MX2-8x8-DH-8DPI-A',
    },
    '-MskKZUXwO1EmaFzs693': {
        apiSyntax: 'mmx',
        cmdPath: '/XP/VIDEO',
        connectionStatus: 'DestinationConnectionStatus',
        firmwareQuery: 'GET /MANAGEMENT/UID.FirmwareVersion',
        name: 'MX2-16x8-HDMI20-AUDIO-R',
    },
    '-MskKZUYysc0dvkZMeKc': {
        apiSyntax: 'mmx',
        cmdPath: '/XP/VIDEO',
        connectionStatus: 'DestinationConnectionStatus',
        firmwareQuery: 'GET /MANAGEMENT/UID.FirmwareVersion',
        name: 'MX2-16x16-HDMI20',
    },
    '-MskKZUYysc0dvkZMeKd': {
        apiSyntax: 'mmx',
        cmdPath: '/VIDEO/XP',
        connectionStatus: 'DestinationConnectionStatus',
        firmwareQuery: 'GET /MANAGEMENT/UID.FirmwareVersion',
        name: 'MX2-24x24-HDMI20',
    },
    '-MskKZUZkZmNukiyCs55': {
        apiSyntax: 'mmx',
        cmdPath: '/XP/VIDEO',
        connectionStatus: 'DestinationConnectionStatus',
        firmwareQuery: 'GET /MANAGEMENT/UID.FirmwareVersion',
        name: 'MX2-24x24-DH-12DPI-R',
    },
    '-MskKZU_Fn5ug3k_YZ4G': {
        apiSyntax: 'mmx',
        cmdPath: '/XP/VIDEO',
        connectionStatus: 'DestinationConnectionStatus',
        firmwareQuery: 'GET /MANAGEMENT/UID.FirmwareVersion',
        name: 'MX2-24x24-DH-24DPIO-R',
    },
    '-MskKZUaJaj2xdfd2CNQ': {
        apiSyntax: 'mmx',
        cmdPath: '/XP/VIDEO',
        connectionStatus: 'DestinationConnectionStatus',
        firmwareQuery: 'GET /MANAGEMENT/UID.FirmwareVersion',
        name: 'MX2-32x32-HDMI20-A-R',
    },
};
export class Lightware {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.log = log;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: 'GET /SYS/MB.FirmwareVersion',
                next: /p[rE]\s+\/SYS\/MB\.FirmwareVersion/i,
            },
        ];
        this.numVideoOutputs = 2;
        this.productInfo = productInfo[failsafeModelNumber];
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.firmwareVersion.value;
            }),
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                if (this.productInfo.apiSyntax === 'mmx') {
                    const product = productInfo[(_a = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _a !== void 0 ? _a : failsafeModelNumber];
                    const firmwareQuery = (_b = product.firmwareQuery) !== null && _b !== void 0 ? _b : 'GET /SYS/MB.FirmwareVersion';
                    const match = yield this.socket.send(firmwareQuery, /(..)\s+.+\.FirmwareVersion[=\s](.+)/i, ['get.firmwareVersion']);
                    if (match[1] === 'pr') {
                        this.state.firmwareVersion.update(match[2]);
                        return true;
                    }
                }
                else {
                    const match = yield this.socket.send(`GET /V1/MANAGEMENT/UID/PACKAGE.Version`, /(..)\s+\/V\d+\/MANAGEMENT\/UID\/PACKAGE.Version=(?:v)?(.+)/i, ['get.firmwareVersion']);
                    if (match[1] === 'pr') {
                        this.state.firmwareVersion.update(match[2]);
                        return true;
                    }
                }
                return false;
            }),
        };
        this.serialNumber = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`GET /.SerialNumber`, /(..)\s+\/\.SerialNumber=([0-9a-z\.]+)/i, ['get.serialNumber']);
                return match[1] === 'pr' ? match[2] : 'unknown';
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                if (this.productInfo.apiSyntax === 'mmx') {
                    return this.state.videoMatrixRoutes.values[key];
                }
                else {
                    const match = yield this.socket.send(`GET /V1/MEDIA/VIDEO/XP/O${key}.ConnectedSource`, /(..)\s+(?:\/V\d+)?\/MEDIA\/VIDEO\/XP\/O\d+.ConnectedSource=I(\d+)/i, tags);
                    return match[1] === 'pw' ? match[2] : this.state.videoMatrixRoutes.values[key];
                }
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _c;
                const prefix = this.productInfo.apiSyntax === 'mmx' ? '' : '/V1';
                const path = `${prefix}/MEDIA${(_c = this.productInfo.cmdPath) !== null && _c !== void 0 ? _c : '/VIDEO/XP'}`;
                const match = yield this.socket.send(`CALL ${path}:switch\(I${value}:O${key}\)`, /(..)\s+(?:\/V\d+)?\/MEDIA\/(?:VIDEO|XP)\/(?:VIDEO|XP):switch/i, tags);
                // USB switching follows video switching to output 1
                if (this.productInfo.hasUsbSwitch && key === '1')
                    this.setUsbRoute(value);
                return match[1] === 'mO' ? value : this.state.videoMatrixRoutes.values[key];
            }),
            asyncHandlers: [
                {
                    // MMX responses
                    regExp: /CHG \/MEDIA\/(?:VIDEO|XP)\/(?:VIDEO|XP)\.DestinationConnection.*=(.+)/i,
                    callback: (match) => {
                        this.updateMatrixRoutes(match[1]);
                    },
                },
                {
                    // UCX responses
                    regExp: /CHG\s+(?:\/V\d+)?\/MEDIA\/VIDEO\/XP\/O(\d+)\.ConnectedSource=I(\d+)/i,
                    callback: (match) => {
                        this.state.videoMatrixRoutes.update(match[1], match[2]);
                    },
                },
            ],
        };
        // Volume adjusts the analog output signal level.
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const prefix = this.productInfo.apiSyntax === 'mmx' ? '' : '/V1';
                const audioOutput = this.productInfo.audioOutput;
                const volumeCommand = this.productInfo.volumeCommand;
                const match = yield this.socket.send(`GET ${prefix}/MEDIA/AUDIO/O${audioOutput}.${volumeCommand}`, /(..)\s+(?:\/V\d+)?\/MEDIA\/AUDIO\/O\d+\.Volume(?:dB)*=(-?[\d\.]+)|%E\d+:.+/i, tags);
                return match[1] === 'pw' ? parseInt(match[2], 10) : this.state.volume.value;
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const prefix = this.productInfo.apiSyntax === 'mmx' ? '' : '/V1';
                const audioOutput = this.productInfo.audioOutput;
                const volumeCommand = this.productInfo.volumeCommand;
                const match = yield this.socket.send(`SET ${prefix}/MEDIA/AUDIO/O${audioOutput}.${volumeCommand}=${volume}`, /(..)\s+(?:\/V\d+)?\/MEDIA\/AUDIO\/O\d+\.Volume(?:dB)*=(-?[\d\.]+)|%E\d+:.+/i, tags);
                return match[1] === 'pw' ? parseInt(match[2], 10) : this.state.volume.value;
            }),
            range: { max: 0, min: -57, round: 1 },
            asyncHandlers: {
                regExp: /CHG\s+(?:\/V\d+)?\/MEDIA\/AUDIO\/O(\d+)\.Volume(?:dB)*=(-?[\d\.]+)/i,
                callback: (match) => {
                    const volume = parseInt(match[2], 10);
                    this.state.volume.update(volume);
                },
            },
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () {
                var _d;
                return (productInfo[(_d = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _d !== void 0 ? _d : failsafeModelNumber].volumeCommand !== undefined);
            }),
        };
        // Volume mute is supported on the analog output channel in the matrix (hence the XP in the
        // command) which is different from the output of the system.
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                if (this.productInfo.apiSyntax === 'mmx') {
                    const match = yield this.socket.send(`GET /MEDIA/AUDIO/XP.DestinationPortStatus`, /(..) \/MEDIA\/AUDIO\/XP.DestinationPortStatus=(.+)|%E\d+:.+/i, tags);
                    return match[1] === 'pr'
                        ? this.parseAudioMute(match[2])
                        : this.state.volumeMute.value;
                }
                else {
                    const match = yield this.socket.send(`GET /V1/MEDIA/AUDIO/XP/O${this.productInfo.audioOutput}.Mute`, /(..) \/V1\/MEDIA\/AUDIO\/XP\/O(\d+).Mute=(true|false)/i, tags);
                    return match[1] === 'pw' ? match[2] === 'true' : this.state.volumeMute.value;
                }
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                var _e;
                if (this.productInfo.apiSyntax === 'mmx') {
                    const audioOutput = this.productInfo.audioOutput;
                    const match = yield this.socket.send(`CALL /MEDIA/AUDIO/XP:${mute ? 'mute' : 'unmute'}Destination(O${audioOutput})`, /(..)\s+(?:\/V\d+)?\/MEDIA\/AUDIO\/XP:(unmute|mute)*Destination|%E\d+:.+/i, tags);
                    return match[1] === 'mO' ? match[2] === 'mute' : this.state.volumeMute.value;
                }
                else {
                    const audioOutput = (_e = this.productInfo.audioOutput) !== null && _e !== void 0 ? _e : 3;
                    const match = yield this.socket.send(`SET /V1/MEDIA/AUDIO/XP/O${audioOutput}.Mute=${mute ? 'true' : 'false'}`, /(..)\s+\/V1\/MEDIA\/AUDIO\/XP\/O(\d+).Mute=(true|false)|%E\d+:.+/i, tags);
                    return match[2] === audioOutput.toString()
                        ? match[1] === 'pw'
                            ? match[3] === 'true'
                            : this.state.volumeMute.value
                        : this.state.volumeMute.value;
                }
            }),
            asyncHandlers: [
                {
                    // MMX responses
                    regExp: /CHG\s+\/MEDIA\/AUDIO\/XP\.(.+)=(.+)/i,
                    callback: (match) => {
                        if (match[1] === 'DestinationPortStatus') {
                            const audioMute = this.parseAudioMute(match[2]);
                            this.state.volumeMute.update(audioMute);
                        }
                    },
                },
                {
                    // UCX responses (tracking mute on the desired audio output)
                    regExp: /CHG\s+(?:\/V\d+)?\/MEDIA\/AUDIO\/XP\/O(\d+).Mute=(true|false)/i,
                    callback: (match) => {
                        var _a;
                        if (match[1] === ((_a = this.productInfo.audioOutput) !== null && _a !== void 0 ? _a : 3).toString()) {
                            this.state.volumeMute.update(match[2] === 'true');
                        }
                    },
                },
            ],
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () {
                var _f;
                return (productInfo[(_f = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _f !== void 0 ? _f : failsafeModelNumber].volumeCommand !== undefined);
            }),
        };
        // polling
        this.polls = [
            {
                intervalMs: 4500,
                controls: ['serialNumber'], // not all models have firmware version
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.numVideoOutputs = Object.keys((_a = config === null || config === void 0 ? void 0 : config.videoOutputs) !== null && _a !== void 0 ? _a : {}).length;
            this.productInfo = productInfo[(_b = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _b !== void 0 ? _b : failsafeModelNumber];
            // Support auto switching on output 1. We only adjust output 1 so that we don't undo any
            // configuration settings used on other outputs.
            if (this.productInfo.hasAutoSwitch) {
                const mode = (config === null || config === void 0 ? void 0 : config.autoSwitchVideoInputs) ? 'O1:E' : 'O1:D';
                yield this.socket.send(`CALL /MEDIA${this.productInfo.cmdPath}:setDestinationPortAutoselect(${mode})`, /mO\s+\/MEDIA\/(?:VIDEO|XP)\/(?:VIDEO|XP):setDestinationPortAutoselect|%E\d+:.+/i, ['configure']);
            }
            // subscribe to video routing changes
            if (this.productInfo.apiSyntax === 'mmx') {
                yield this.socket.send(`OPEN /MEDIA${this.productInfo.cmdPath}`, /o-\s(?:\/V\d+)?\/MEDIA\/(?:VIDEO|XP)\/(?:VIDEO|XP)|%E\d+:.+/i, ['configure']);
            }
            else {
                // must register the video crosspoints to get async matrix routing change information
                yield this.socket.send(`OPEN /V1/MEDIA/VIDEO/XP/*`, /o-\s(?:\/V\d+)?\/MEDIA\/VIDEO\/XP|%E\d+:.+/i, ['configure']);
            }
            // subscribe to audio mute changes
            if (this.productInfo.apiSyntax === 'mmx') {
                yield this.socket.send(`OPEN /MEDIA/AUDIO/XP`, /o-\s(?:\/V\d+)?\/MEDIA\/AUDIO\/XP|%E\d+:.+/i, ['configure']);
            }
            else {
                yield this.socket.send(`OPEN /V1/MEDIA/AUDIO/XP/O${this.productInfo.audioOutput}`, /o-\s(?:\/V\d+)?\/MEDIA\/AUDIO\/XP\/O(\d+)|%E\d+:.+/i, ['configure']);
            }
            // subscribe to audio volume changes
            if (this.productInfo.audioOutput) {
                if (this.productInfo.apiSyntax === 'mmx') {
                    yield this.socket.send(`OPEN /MEDIA/AUDIO/O${this.productInfo.audioOutput}.${this.productInfo.volumeCommand}`, /o-\s(?:\/V\d+)?\/MEDIA\/AUDIO\/O\d+|%E\d+:.+/i, ['configure']);
                }
                else {
                    yield this.socket.send(`OPEN /V1/MEDIA/AUDIO/O${this.productInfo.audioOutput}`, /o-\s(?:\/V\d+)?\/MEDIA\/AUDIO\/O\d+|%E\d+:.+/i, ['configure']);
                }
            }
            if (this.productInfo.apiSyntax === 'mmx') {
                yield this.queryMatrixRoutes(false);
            }
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
    // other class methods
    parseAudioMute(statusString) {
        // process match of the form: T000F;T000F;M000F
        var _a, _b;
        const outputStatus = statusString.split(';');
        const outputChan = outputStatus.length >= ((_a = this.productInfo.audioOutput) !== null && _a !== void 0 ? _a : 3)
            ? outputStatus[((_b = this.productInfo.audioOutput) !== null && _b !== void 0 ? _b : 3) - 1]
            : outputStatus[outputStatus.length - 1];
        // T = unmuted, unlocked
        // L = unmuted, locked
        // M = muted, unlocked
        // U = muted, locked
        return outputChan.startsWith('M') || outputChan.startsWith('U');
    }
    queryMatrixRoutes(isPoll = false) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.productInfo.apiSyntax !== 'mmx') {
                this.log.error(`expected mmx syntax`);
                return;
            }
            const tags = isPoll
                ? ['poll', 'get.videoMatrixRoutes']
                : ['get.videoMatrixRoutes'];
            const statusCmd = (_a = this.productInfo.connectionStatus) !== null && _a !== void 0 ? _a : 'DestinationConnectionList';
            const match = yield this.socket.send(`GET /MEDIA${this.productInfo.cmdPath}.${statusCmd}`, /pr\s+\/MEDIA\/.+\.DestinationConnection.+=([I\d+;]+)/, tags);
            yield this.updateMatrixRoutes(match[1]);
        });
    }
    updateMatrixRoutes(routes) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.productInfo.apiSyntax !== 'mmx') {
                this.log.error(`expected mmx syntax`);
                return;
            }
            // process match of the form: I1;I3;I6;I4 corresponding to outputs 1 - 4
            const inputsToOutputs = routes.split(';');
            for (let i = 0; i < inputsToOutputs.length; i++) {
                if (inputsToOutputs[i].length > 1 && i < this.numVideoOutputs) {
                    const inputNum = inputsToOutputs[i].slice(1);
                    this.state.videoMatrixRoutes.update(`${i + 1}`, inputNum);
                    // If USB switching supported, set the USB routing to match the video selection
                    // routed to output 1.
                    if (this.productInfo.hasUsbSwitch && i === 0)
                        yield this.setUsbRoute(inputNum);
                }
            }
        });
    }
    setUsbRoute(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const match = yield this.socket.send(`SET /MEDIA/USB/USBSWITCH.HostSelect=${value}`, /(..)\s+\/MEDIA\/USB\/USBSWITCH.HostSelect=(\d+)/i, ['usbSyncToVideo']);
            if (match[1] !== 'pw')
                this.log.warning(`usb switching not successful`);
        });
    }
}
// static properties
Lightware.driverType = 'socketDriver';
Lightware.key = '-MKL6-l0wZhGgfmsnh9M';
Lightware.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r\n',
};
Lightware.socketOptions = [
    Object.assign(Object.assign({}, Lightware.baseSocketOptions), { port: 6107 }),
    Object.assign(Object.assign({}, Lightware.baseSocketOptions), { port: 4999 }),
];
